// =============================================================================
// Supabase client — frontend (browser)
// =============================================================================
// Uses the PUBLISHABLE key (safe for browser).
// All RLS policies enforce permissions; never bypass with secret key on client.
// =============================================================================

import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!url || !key) {
  console.warn('[supabase] VITE_SUPABASE_URL or VITE_SUPABASE_PUBLISHABLE_KEY missing');
}

export const supabase = createClient(url, key);
